import { render, staticRenderFns } from "./UsernameTextbox.vue?vue&type=template&id=ddfe72e2&scoped=true"
import script from "./UsernameTextbox.vue?vue&type=script&lang=js"
export * from "./UsernameTextbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe72e2",
  null
  
)

export default component.exports